export default __webpack_public_path__ + "static/media/end-game.02658909.md";